export default {
  QUESTION: 'Pregunta',
  QUESTION_TYPE: 'Tipo de pregunta',
  EMPTY_OPTIONS: 'Proporcione una opción de valores.',
  FILL_REQUIRED_VALUES: 'Rellene los valores requeridos.',
  DELETE_QUESTION_POPUP_TITLE: '¿Borrar pregunta?',
  DELETE_QUESTION_POPUP_LABEL:
    'Una vez eliminada, la pregunta no será visible en la aplicación y debe añadirse de nuevo si desea recuperarla.',
  FORM_UPDATE_SUCCESS: 'Su formulario se ha actualizado correctamente!',
  CHOOSE_ANS_TYPE: 'Elija un tipo de respuesta',
  SETUP_QUESTION: 'Configurar preguntas de calificación',
  SETUP_QUESTION_INFO: 'Modifique las preguntas para calificar a sus clientes potenciales; los cambios se actualizarán en su aplicación.',
  FIX_QUESTION_INFO: 'Esta pregunta es obligatoria en la aplicación y no se puede editar ni cambiar.',
  NEW_QUESTION_BTN: 'Pulse aquí para añadir una nueva pregunta'
}
